import { jsx, jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Button, Classes, Spinner, InputGroup } from "@blueprintjs/core";
import classNames from "classnames";
import { onEnterHelper } from "../utils/handlerHelpers";
const SearchBar = ({
  searchInput,
  setSearchTerm,
  loading,
  searchMenuButton,
  disabled,
  autoFocusSearch,
  noForm
}) => {
  const [inputText, setInputText] = useState(searchInput || "");
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchTerm(inputText);
    }, 100);
    return () => clearTimeout(handler);
  }, [inputText, setSearchTerm]);
  if (noForm) {
    console.error(
      "The search bar requires the component to be wrapped in a form"
    );
    return;
  }
  let rightElement;
  if (searchMenuButton) {
    rightElement = /* @__PURE__ */ jsxs("div", { style: { display: "flex" }, children: [
      loading && /* @__PURE__ */ jsx(Spinner, { size: "18" }),
      searchMenuButton
    ] });
  } else {
    rightElement = loading ? /* @__PURE__ */ jsx(Spinner, { size: "18" }) : /* @__PURE__ */ jsx(
      Button,
      {
        minimal: true,
        icon: "search",
        onClick: () => {
          setSearchTerm(inputText);
        }
      }
    );
  }
  return /* @__PURE__ */ jsx(
    InputGroup,
    {
      autoFocus: autoFocusSearch,
      disabled,
      type: "search",
      value: inputText,
      onChange: (e) => {
        setInputText(e.target.value);
      },
      className: classNames("datatable-search-input", Classes.ROUND),
      placeholder: "Search...",
      ...onEnterHelper((e) => {
        e.preventDefault();
        e.stopPropagation();
        setSearchTerm(e.target.value);
        e.nativeEvent.stopImmediatePropagation();
      }),
      rightElement
    }
  );
};
export default SearchBar;
